import React from 'react';

const withDefaultIconProps = (IconComponent) => {
  return function WithDefaultProps(props) {
    return (
      <IconComponent
        {...props}
        color="#000000"
        width="1.042vw"
        height="1.042vw"
      />
    );
  };
};

export default withDefaultIconProps;
